import React, { useCallback } from 'react';

import Table from '../shared/table/Table';

const columns = [
  { title: '', field: 'caseStatus', type: 'caseStatus', sort: false },
  { title: 'case date', field: 'date', type: 'date', sort: true },
  { title: 'surgeon', field: 'surgeonName', type: 'default', sort: true },
  { title: 'hospital', field: 'hospitalName', type: 'default', sort: true },
  { title: 'state', field: 'hospitalState', type: 'default', sort: true },
  { title: 'patient ref', field: 'patientReference', type: 'default', sort: true },
  { title: 'procedure', field: 'procedureName', type: 'default', sort: true },
];

const reportColumns = [
  { title: '', field: 'caseStatus', type: 'caseStatus', sort: false },
  { title: 'case date', field: 'date', type: 'date', sort: true },
  { title: 'surgeon', field: 'surgeonName', type: 'default', sort: true, filter: true, filterTitle: 'Filter Surgeons' },
  { title: 'hospital', field: 'hospitalName', type: 'default', sort: true, filter: true, filterTitle: 'Filter Hospitals' },
  { title: 'state', field: 'hospitalState', type: 'default', sort: true },
  { title: 'created by', field: 'userName', type: 'default', sort: true },
  { title: 'procedure', field: 'procedureName', type: 'default', sort: true, filter: true, filterTitle: 'Filter Procedures' },
];

const CasesTableContainer = (props) => {
  const {
    onSelectCase,
    cases,
    selectedCaseId,
    handleCheck,
    checkedCases,
    handleCheckAll,
    surgeons,
    hospitals,
    procedures,
    users = [],
    withoutCheck,
    rowColor,
    rowBorderColor,
    pagination,
    checkboxes,
    isReport,
    filter,
    filterOptions,
    onFilterChange,
    loading,
  } = props;

  const getSurgeonName = useCallback((surgeonId, surgeonName = '') => {
    const surgeon = surgeons?.find((surgeon) => surgeon.id === surgeonId);
    return surgeon ? `${surgeon.title} ${surgeon.firstName} ${surgeon.lastName}` : surgeonName;
  }, [surgeons]);

  const getHospitalName = useCallback((hospitalId, hospitalName = '') => {
    const hospital = hospitals?.find((hospital) => hospital.id === hospitalId);
    return hospital ? hospital.name : hospitalName;
  }, [hospitals]);

  const getHospitalState = useCallback((hospitalId, hospitalState = '') => {
    const hospital = hospitals?.find((hospital) => hospital.id === hospitalId);
    return hospital ? hospital.state : hospitalState;
  }, [hospitals]);

  const getProcedureName = useCallback((procedureId, procedureName = '') => {
    const procedure = procedures?.find((procedure) => procedure.id === procedureId);
    return procedure ? procedure.name : procedureName;
  }, [procedures]);

  const getUserName = useCallback((uid) => {
    const user = users?.find((u) => u.uid === uid);
    return user ? `${user.firstName} ${user.lastName}` : '';
  }, [users]);

  return (
    <div style={{ width: '100%' }}>
      <Table
        className='cases-table'
        rows={cases.map((item) => ({
          ...item,
          surgeonName: getSurgeonName(item.surgeon, item.surgeonName),
          hospitalName: getHospitalName(item.hospital, item.hospitalName),
          hospitalState: getHospitalState(item.hospital, item.hospitalState),
          procedureName: getProcedureName(item.procedure, item.procedureName),
          caseStatus: {
            status: item.status,
            canceled: !item.active,
            kitVariant: item.kitVariant,
            additional: item.hasAdditionalEquipment,
            // additional: !!item.additionalKits?.length || !!item.additionalItems?.length,
          },
          userName: getUserName(item.createdBy),
        }))}
        columns={isReport ? reportColumns : columns}
        onRowClick={onSelectCase}
        selected={selectedCaseId}
        handleCheck={handleCheck}
        checkedRows={checkedCases}
        handleCheckAll={handleCheckAll}
        withoutCheck={withoutCheck}
        rowColor={rowColor}
        rowBorderColor={rowBorderColor}
        pagination={pagination}
        checkboxes={checkboxes}
        currentFilter={filter}
        filterOptions={filterOptions}
        onFilterChange={onFilterChange}
        noCheckAll
        loading={loading}
      />
    </div>
  );
};

export default CasesTableContainer;
